var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"button is-info is-outlined",class:{ 'is-loading': _vm.is_loading },staticStyle:{"color":"black"},on:{"click":_vm.previewInPanel}},[_vm._v("preview_in_panel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }